'use strict';

const DEALER_SELECT_CLICK_EVENT = 'click.productPurchaseDelegated';
const DEALER_SELECT_SELECTOR = '.offer-dealer-list .dealer-select-button';

function handleDealerSelect(evt) {
	evt.preventDefault();
	const dealerHash = rp$(evt.currentTarget).data('fulfillment-hash');
	if (!dealerHash) {
		return;
	}

	globalThis.rp_app?.invalidateSupplierCache?.();

	$ajax({
		method: 'POST',
		dataType: 'json',
		url: '/ajax/dealers',
		data: {
			dealerHash,
		},
		success: (_response, status) => {
			if (status === 'success') {
				globalThis.rp_app.location.reload();
			}
		},
	});
}

/** Document-delegated Shop Now — safe to call after offers HTML lands and from product_purchase ready. */
function bindDealerSelectShopNow() {
	const $document = rp$(document);
	if (!$document || typeof $document.off !== 'function' || typeof $document.on !== 'function') {
		return;
	}

	$document.off(DEALER_SELECT_CLICK_EVENT, DEALER_SELECT_SELECTOR);
	$document.on(DEALER_SELECT_CLICK_EVENT, DEALER_SELECT_SELECTOR, handleDealerSelect);
}

module.exports = {
	DEALER_SELECT_CLICK_EVENT,
	DEALER_SELECT_SELECTOR,
	bindDealerSelectShopNow,
	handleDealerSelect,
};
